<footer class="footer">
  <div class="footer__left">
    <p class="footer__left__paragraph">¿Tienes problemas? <strong>Levanta un ticket</strong> al área de Continuidad Operacional:</p>
    <a href="https://jira.falabella.tech/plugins/servlet/theme/portal/2/group/9" target="_blank" class="footer__left__link">
      https://jira.falabella.tech/plugins/servlet/theme/portal/2/group/9
    </a>
  </div>

  <img class="footer__center-logo" src="assets/images/logos/sodimac-footer.png" alt="">

  <div class="footer__right">
    <p class="footer__right__paragraph">Arriendo de herramientas, que nada interrumpa tus proyectos.</p>
    <p class="footer__right__paragraph"><span>® {{ date | date: 'yyyy' }} Sodimac S. A. | Version: {{ version }}</span></p>
  </div>
</footer>
